import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { ModuleType } from '../../types/modules';
import {
  finishSaving,
  saveActiveSkin,
  toggleSkinSelector,
} from '../actions/profileSkins';
import {
  getModuleIdByModuleType,
  getModuleVersion,
} from '../selectors/modules';
import { putErrorNotification } from '@wix/da-shared-react/pkg/utils/saga';
import i18next from 'i18next';
import {
  getCurrentUser,
  getCurrentUserHasCore,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  PapiDaUserProfileModuleCoverDeviationSaveSkin,
  PapiRequestDaUserProfileModuleCoverDeviationSaveSkin,
  PapiUser,
} from '@wix/da-papi-types';
import { getActiveSkin } from '../selectors/profileSkins';
import { ProfileSkin } from '../../types/profileSkins';
import { isApiError, request, XhrResponse } from '@wix/da-shared-react/pkg/xhr';
import { API_BASE_PATH } from '../../constants';
import { runModuleInitActions } from './modules';

function* handleSaveActiveSkin() {
  const moduleId: number = yield select(
    getModuleIdByModuleType,
    ModuleType.COVER_DEVIATION
  );
  const moduleVersion: number = yield select(getModuleVersion, moduleId);
  const currentUser: PapiUser = yield select(getCurrentUser);
  const currentUserHasCore: boolean = yield select(getCurrentUserHasCore);
  const activeSkin: ProfileSkin = yield select(getActiveSkin);

  if (!currentUserHasCore) {
    yield put(toggleSkinSelector());
    return;
  }

  if (moduleId === undefined || moduleVersion === undefined || !currentUser) {
    yield putErrorNotification(
      i18next.t('skin.selector.save.error.noModuleFatal')
    );
    yield put(finishSaving());
    return;
  }

  const data: PapiRequestDaUserProfileModuleCoverDeviationSaveSkin = {
    moduleid: moduleId,
    username: currentUser.username,
    version: moduleVersion,
    profile_skin_template_name: activeSkin.skinId,
  };

  const response: XhrResponse<PapiDaUserProfileModuleCoverDeviationSaveSkin> =
    yield call(request, {
      baseURL: API_BASE_PATH,
      method: 'post',
      url: '/module/cover_deviation/save_skin',
      data,
    });
  if (!response || isApiError(response) || !response.moduleData) {
    yield putErrorNotification(
      i18next.t('skin.selector.save.error.saveFailed')
    );
    yield put(finishSaving());
    return;
  }

  if (response.moduleData) {
    yield call(runModuleInitActions, response);
  }

  yield put(toggleSkinSelector());
}

export default function* rootProfileSkinsSaga() {
  yield all([takeEvery(saveActiveSkin, handleSaveActiveSkin)]);
}
